import { queryKeys } from '@/lib/query-client';
import { useQuery } from '@tanstack/react-query';
import { getJobMilestoneHistory } from '../api/jobDetailApi';

const MILESTONE_POLL_INTERVAL_MS = 5000;

export interface MilestonePollOptions {
  isInFlight?: boolean;
}

export function shouldPollForMilestones(options: MilestonePollOptions | undefined): boolean {
  return options?.isInFlight ?? false;
}

/**
 * CWL-386: `isInFlight` is computed by the caller from the job's own
 * lifecycle status (JobDetailsView already holds it via useJobData) — this
 * hook has no status field of its own to poll against.
 */
export function useJobMilestoneHistory(jobId: number, options: MilestonePollOptions = {}) {
  return useQuery({
    queryKey: queryKeys.jobs.milestoneHistory(String(jobId)),
    queryFn: () => getJobMilestoneHistory(jobId),
    enabled: jobId > 0,
    refetchInterval: shouldPollForMilestones(options) ? MILESTONE_POLL_INTERVAL_MS : false,
  });
}
